import { useContext, useEffect } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ThemeProvider } from "@mui/material/styles";
import { Alert, Snackbar, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import StylesProvider from "@mui/styles/StylesProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import "./css/style.css";
import createTheme from "./theme";
import Router from "./router/Router";
import useIsMobile from "./hooks/useDeviceInfo";
import useAuthToken from "./hooks/useAuthToken";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useBuildVersionCheck } from "./hooks/useBuildVersionCheck";
import { setAccessToken, setDisplayName } from "./redux/slices/memberSlice";
import useServiceWorkerRegistration from "./hooks/useServiceWorkerRegistration";
import InternetChecker from "./utils/InternetChecker";

function App() {
  const { theme } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alertDetails);

  useAuthToken();
  useBuildVersionCheck();
  useServiceWorkerRegistration();

  useEffect(() => {
    dispatch(setAccessToken(sessionStorage.getItem("authToken")));
    dispatch(setDisplayName(sessionStorage.getItem("displayName")));
  }, [dispatch]);

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | Verismart.ai" defaultTitle="Verismart AI" />

      <StylesProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MuiThemeProvider theme={createTheme(theme)}>
            <ThemeProvider theme={createTheme(theme)}>
              <Snackbar
                open={alert.state}
                autoHideDuration={4000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                TransitionComponent={(props) => (
                  <Slide
                    {...props}
                    in={alert.state}
                    direction="right"
                    unmountOnExit
                  />
                )}
                style={{
                  top: "50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <Alert
                  variant="outlined"
                  severity={alert.type}
                  onClose={handleAlertClose}
                  sx={{
                    minWidth: "350px",
                    background: "white",
                    borderRadius: "10px",
                    marginTop: "10px",
                  }}
                >
                  {alert.message}
                </Alert>
              </Snackbar>
              <InternetChecker />
              <Router />
            </ThemeProvider>
          </MuiThemeProvider>
        </LocalizationProvider>
      </StylesProvider>
    </HelmetProvider>
  );

  function handleAlertClose(_, reason) {
    if (reason === "clickaway") {
      return;
    }

    dispatch(closeAlert());
  }
}

export default App;
